import CompanyIndex from "@/components/company/CompanyIndex.vue";
import CompanyAdd from "@/components/company/CompanyAdd.vue";
import CompanyDetail from "@/components/company/CompanyDetail.vue";
import CompanyEdit from "@/components/company/CompanyEdit.vue";
import CompanyUpload from "@/components/company/CompanyUpload.vue";

let routesCompanyAccess= [
    {
        path: '',
        meta: {
          title: "List Company Access",
        },
        name: "CompanyIndex",
        component: CompanyIndex
    },
    {
        path: 'create',
        meta: {
          title: "Create Company Access",
        },
        name: "CompanyAdd",
        component: CompanyAdd
    },
     
    {
        path: 'detail/:id',
        meta: {
          title: "Detail Company Access",
        },
        name: "CompanyDetail",
        component: CompanyDetail
    },
     
    {
        path: 'edit/:id',
        meta: {
          title: "Edit Company Access",
        },
        name: "CompanyEdit",
        component: CompanyEdit
    },
     
    {
        path: 'upload',
        meta: {
          title: "Upload Company Access",
        },
        name: "CompanyUpload",
        component: CompanyUpload
    },
    
]

export default routesCompanyAccess
  